import * as React from 'react';

import { IGlob } from '../../../../_common/application/ts/Glob';
import { Module } from '../Module';
import GlobalState from '../../../../_common/platform/ts/globalStates/GlobalState';
import { WidgetStore } from '../stores/WidgetStore';
import { GaugeStore } from '../stores/GaugeStore';
import { Dispatcher as GaugeDispatcher } from '../stores/Dispatcher';
import { Actions as GaugeActions } from '../stores/GaugeActions';
import { IWidgetOptions } from '../../../../pdc-platform/src/ts/Interfaces';
import { themeVars } from '../../../../pdc-platform/src/ts/themes/themeConstants';
import { IValuesCollection } from '../../../../_common/platform/ts/appTheme';

interface IProps {
    glob: IGlob;
    theme: IValuesCollection;
}

const CircularPreview: React.FC<IProps> = ({ glob, theme }) => {
    const options: IWidgetOptions = {
        tab: 0,
        namespace: '',
        displayMode: 'main',
        distractFree: false,
        theme: theme,
        themeContext: 'section-preview'
    };

    const widgetConfig = {
        type: 'pdc-widget-gauge',
        values: {
            'pdc-widget-gauge': {
                name: 'Cisrcular Gauge',
                theme: theme,
                values: [
                    {
                        attribute: {
                            aggregateGroup: 'none',
                            type: 'i',
                            defAttrAbsent: true,
                            expression: {
                                rettype: 'r',
                                syntaxTree: {
                                    number: 90
                                },
                                label: 'Users'
                            },
                            subValueType: 'main'
                        },
                        dataSourceID: 1,
                        filter: []
                    },
                    {
                        attribute: {
                            aggregateGroup: 'none',
                            type: 'i',
                            defAttrAbsent: true,
                            expression: {
                                rettype: 'r',
                                syntaxTree: {
                                    number: 50
                                }
                            },
                            label: 'Active',
                            subValueType: 'sub'
                        },
                        dataSourceID: 1,
                        filter: []
                    }
                ],
                gaugeFromToField: {
                    startValue: 0,
                    startValueExplicit: true,
                    startValueLookup: {
                        attribute: null,
                        distinct: false,
                        filters: []
                    },
                    endValue: null,
                    endValueExplicit: false,
                    endValueLookup: {
                        filters: [],
                        type: 'i',
                        aggregateGroup: 'string_agg',

                        expression: {
                            rettype: 'r',
                            syntaxTree: {
                                number: 100
                            }
                        }
                    },
                    dataSourceID: 1
                }
            }
        },
        cid: 1623344128455,
        id: 1623344128455
    };

    const globalState = GlobalState.createFactory(glob, -1, 0, '', null);

    const store: WidgetStore = WidgetStore.get(glob, glob.AppDispatcher, widgetConfig, options, globalState);

    const gaugeD = GaugeDispatcher.get();
    const gaugeA = GaugeActions.get(gaugeD);
    const gaugeStore = GaugeStore.get(glob, gaugeD, gaugeA, options, globalState);

    return <Module store={store} gaugeStore={gaugeStore} options={options} glob={glob} />;
};

const LinearPreview: React.FC<IProps> = ({ glob, theme }) => {
    const options: IWidgetOptions = {
        tab: 0,
        namespace: '',
        displayMode: 'main',
        distractFree: false,
        theme: theme,
        themeContext: 'section-preview'
    };
    const widgetConfig = {
        type: 'pdc-widget-gauge',
        values: {
            'pdc-widget-gauge': {
                gaugeType: 'linearGauge',
                name: 'Linear Gauge',
                theme: theme,
                values: [
                    {
                        attribute: {
                            aggregateGroup: 'none',
                            type: 'i',
                            defAttrAbsent: true,
                            expression: {
                                rettype: 'r',
                                syntaxTree: {
                                    number: 90
                                },
                                label: 'Users'
                            },
                            subValueType: 'main'
                        },
                        dataSourceID: 1,
                        filter: []
                    },
                    {
                        attribute: {
                            aggregateGroup: 'none',
                            type: 'i',
                            defAttrAbsent: true,
                            expression: {
                                rettype: 'r',
                                syntaxTree: {
                                    number: 50
                                },
                                label: 'Active'
                            },
                            subValueType: 'sub'
                        },
                        dataSourceID: 1,
                        filter: []
                    }
                ],
                gaugeFromToField: {
                    startValue: 0,
                    startValueExplicit: true,
                    startValueLookup: {
                        attribute: null,
                        distinct: false,
                        filters: []
                    },
                    endValue: null,
                    endValueExplicit: false,
                    endValueLookup: {
                        aggregateGroup: 'string_agg',
                        type: 'i',
                        expression: {
                            rettype: 'r',
                            syntaxTree: {
                                number: 100
                            }
                        }
                    },
                    dataSourceID: 1
                }
            }
        },
        cid: 1624023303436,
        id: 1624023303436
    };

    const globalState = GlobalState.createFactory(glob, -1, 0, '', null);

    const store: WidgetStore = WidgetStore.get(glob, glob.AppDispatcher, widgetConfig, options, globalState);

    const gaugeD = GaugeDispatcher.get();
    const gaugeA = GaugeActions.get(gaugeD);

    const gaugeStore = GaugeStore.get(glob, gaugeD, gaugeA, options, globalState);

    return <Module store={store} gaugeStore={gaugeStore} options={options} glob={glob} />;
};

const BarPreview: React.FC<IProps> = ({ glob, theme }) => {
    const options: IWidgetOptions = {
        tab: 0,
        namespace: '',
        displayMode: 'main',
        distractFree: false,
        theme: theme,
        themeContext: 'section-preview'
    };
    const widgetConfig = {
        type: 'pdc-widget-gauge',
        values: {
            'pdc-widget-gauge': {
                gaugeType: 'barGauge',
                theme: theme,
                values: [
                    {
                        attribute: {
                            aggregateGroup: 'none',
                            type: 'i',
                            defAttrAbsent: true,
                            label: 'Users',
                            expression: {
                                rettype: 'r',
                                syntaxTree: {
                                    number: 90
                                }
                            },
                            subValueType: 'main'
                        },
                        dataSourceID: 1,
                        filter: []
                    },
                    {
                        attribute: {
                            aggregateGroup: 'none',
                            type: 'i',
                            defAttrAbsent: true,
                            label: 'Active',
                            expression: {
                                rettype: 'r',
                                syntaxTree: {
                                    number: 50
                                }
                            },
                            subValueType: 'sub'
                        },
                        dataSourceID: 1,
                        filter: []
                    }
                ],
                gaugeFromToField: {
                    startValue: 0,
                    startValueExplicit: true,
                    startValueLookup: {
                        attribute: null,
                        distinct: false,
                        filters: []
                    },
                    endValue: null,
                    endValueExplicit: false,
                    endValueLookup: {
                        attrType: 'i',
                        aggregateGroup: 'string_agg',
                        expression: {
                            rettype: 'r',
                            syntaxTree: {
                                number: 100
                            }
                        },
                        filters: []
                    },
                    dataSourceID: 1
                },
                name: 'Bar Gauge'
            }
        },
        cid: 1624027789370,
        id: 1624027789370
    };

    const globalState = GlobalState.createFactory(glob, -1, 0, '', null);

    const store: WidgetStore = WidgetStore.get(glob, glob.AppDispatcher, widgetConfig, options, globalState);

    const gaugeD = GaugeDispatcher.get();
    const gaugeA = GaugeActions.get(gaugeD);

    const gaugeStore = GaugeStore.get(glob, gaugeD, gaugeA, options, globalState);

    return <Module store={store} gaugeStore={gaugeStore} options={options} glob={glob} />;
};

export function ThemePreview(glob, theme) {
    let titlePre = 'Gauge Widget';
    let headerContainer;

    if (theme[themeVars.widget_AlwaysShowHeader] === true) {
        headerContainer = (
            <div className="widget-control-panel">
                <span>{titlePre}</span>
                <span className="glyphicon glyphicon-remove remove-button header-button"></span>
                <span className="glyphicon glyphicon-cog config-button header-button"></span>
                <span className="glyphicon glyphicon-chevron-down menu-button header-button"></span>
            </div>
        );
    }
    return [
        <div key="widget-keycircle" className="widget">
            <div className="widget-inner-container">
                {headerContainer}
                <div className="show-header-button">
                    <span className="glyphicon glyphicon-chevron-down"></span>
                </div>
                <div className="widget-canvas widget-canvas-main">
                    <div className="pdc-widget-gauge">
                        <CircularPreview glob={glob} theme={theme} />
                    </div>
                </div>
            </div>
        </div>,
        <div key="widget-keylinear" className="widget">
            <div className="widget-inner-container">
                {headerContainer}
                <div className="show-header-button">
                    <span className="glyphicon glyphicon-chevron-down"></span>
                </div>
                <div className="widget-canvas widget-canvas-main">
                    <div className="pdc-widget-gauge">
                        <LinearPreview glob={glob} theme={theme} />
                    </div>
                </div>
            </div>
        </div>,
        <div key="widget-keybar" className="widget">
            <div className="widget-inner-container">
                {headerContainer}
                <div className="show-header-button">
                    <span className="glyphicon glyphicon-chevron-down"></span>
                </div>
                <div className="widget-canvas widget-canvas-main">
                    <div className="pdc-widget-gauge">
                        <BarPreview glob={glob} theme={theme} />
                    </div>
                </div>
            </div>
        </div>
    ];
}
